module.exports = __webpack_public_path__ + "media/images/weather/103_night-69e3429f6b39df774bfd096c34e203cb.png";